import Quill from 'quill';

const SizeStyle = Quill.import('attributors/style/size');

export const MIN_SIZE = 1;
export const MAX_SIZE = 200;

const sizesArray = Array.from(
  { length: MAX_SIZE - MIN_SIZE + 1 },
  (_, i) => `${MIN_SIZE + i}px`,
);

SizeStyle.whitelist = sizesArray;

export default SizeStyle;
